// @flow
import { init } from './App'
init()
